import { ReactNode } from 'react';

import { IconCheckDefault, IconExclamationTriangleFilled } from '@iwoca/icons';
import { AlertBox } from '@iwoca/orion';

import styles from './DocumentRequirementStep.module.css';
import { Button } from '../../../Button/Button';
import { useStep } from '../StepContext';

type TProps = {
  children: ReactNode;
};

const DocumentRequirementStep = ({ children }: TProps) => {
  const {
    index,
    title,
    errorMessage,
    isActive,
    isComplete,
    isError,
    isLastStep,
    onContinue,
  } = useStep();

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleRow}>
          {isComplete && (
            <IconCheckDefault
              width={20}
              height={20}
              className={styles.checkIcon}
              data-testid="step-complete-icon"
            />
          )}
          <h3 className={styles.title}>
            <span className={styles.stepNumber}>{index + 1}.</span> {title}
          </h3>
        </div>
      </div>
      <div className={styles.content}>
        {children}
        {isError && errorMessage && !isComplete && (
          <AlertBox variant="failure" className={styles.errorMessage}>
            <IconExclamationTriangleFilled className={styles.errorIcon} />
            {errorMessage}
          </AlertBox>
        )}
        {isActive && (
          <Button className={styles.continueButton} onClick={onContinue}>
            {isLastStep ? 'Continue to summary' : 'Continue to next step'}
          </Button>
        )}
      </div>
    </div>
  );
};

export default DocumentRequirementStep;
